import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, EventEmitter, HostListener,
  Input, OnChanges,
  OnInit, Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
// @ts-ignore
import $ from 'jquery';
import { SchedulingService } from './scheduling.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DxSchedulerComponent } from 'devextreme-angular';

import { MatSnackBar } from '@angular/material/snack-bar';
import * as events from 'devextreme/events';

import { PatientEditComponent } from '../patient/patient-edit/patient-edit.component';
import Button from 'devextreme/ui/button';
import { Globals } from '../../globals';
import { FormsService } from '../forms/forms.service';
import { PatientDialogDataModel } from '../patient/patient-dialog-data.model';
import { ScheduleTimeService } from '../../services/configuration/schedule-time.service';
import { ScheduleTimesModel } from '../../models/schedule/schedule-times.model';
import { ColorSchemesService } from '../configuration/color-schemes/color-schemes.service';
import { ColorSchemeDataModel } from '../../models/configuration/color-scheme-data.model';
import { StaticDataService } from '../../services/static-data.service';
import { NonWorkingDaysService } from '../../services/configuration/non-working-days.service';
import { NonWorkingDayModel } from '../../models/configuration/nonWorkingDays/non-working-day.model';
import { OperatoryDataModel } from '../../models/clients/operatory-data.model';
import { ConversionUtilities } from '../../utilities/conversion.utilities';
import { EnumValidValueItemModel } from '../../models/enum/enum-valid-value-item.model';
import { Subscription } from 'rxjs';
import { UntypedFormControl, Validators } from '@angular/forms';
import { SignalrService } from '../../services/socket/signalr.service';
import { DoctorsService } from '../../services/doctors.service';
import { DoctorQueryOptionsModel } from '../../models/doctors/doctor-query-options.model';
import { DoctorDataModel } from '../../models/doctors/doctor-data.model';
import { LandingPageService } from '../../services/landing-page.service';
import { PatientCaseViewDataModel } from '../../models/patient/patient-case-view-data.model';
import { PatientService } from '../patient/patient.service';
import { PatientCheckinDialogComponent } from '../../dialog/patient-checkin-dialog/patient-checkin-dialog.component';
import { DataAppointmentModel } from '../../models/appointments/data-appointment.model';
import { PatientFlagDataModel } from '../../models/patient/patient-flag-data.model';
import { AppointmentFlagDataModel } from '../../models/appointments/appointment-flag-data.model';
import { CaseProcedureConfigurationModel } from '../../models/caseProcedures/case-procedure-configuration.model';
import {
  MedicalInformationAppointmentDialogComponent
} from '../../dialog/medical-information-appointment-dialog/medical-information-appointment-dialog.component';
import { MessagingConstants } from '../../models/MessagingConstants';
import { MessagingService } from '../../services/messaging.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../auth/services/authentication.service';
import { TdoUserConfigurationModel } from '../../models/configuration/user/tdo-user-configuration.model';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { ToothUiManagerModel } from '../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { ClientLocationDataModel } from '../../models/clients/client-location-data.model';
import { AppointmentDialogComponent } from './dialog/appointment-dialog/appointment-dialog.component';
import { ApptStatusEnum } from '../../models/enum/appt-status.enum';
import { AppointmentDialogDataModel } from './models/appointment-dialog-data.model';
import { FlagsService } from '../../services/flags.service';
import { AppointmentOperatoryDataModel } from '../../models/appointments/appointment-operatory-data.model';
import moment from "moment";
import { ApptTypeEnum } from 'src/app/models/enum/appt-type.enum';
import DevExpress from 'devextreme';
import ContextMenuItem = DevExpress.ui.dxGantt.ContextMenuItem;
import {formatDate} from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulingComponent implements OnInit, AfterViewInit, OnChanges {
  tdoScheduler: DxSchedulerComponent;

  @ViewChild('tdoScheduler', { static: false }) set tdoxScheduler(content: DxSchedulerComponent) {
    if (content) {
      this.tdoScheduler = content;
    }
  }

  @Input() viewType: string = 'day';
  @Input() tdoCurrentDate: Date;
  @Input() operatoryDataModels: OperatoryDataModel[];
  @Input() isDailyDetail: boolean = false;

  @Output() appointmentDialogDataForWaitList = new EventEmitter<AppointmentDialogDataModel>();

  myControl: UntypedFormControl;
  users: TdoUserConfigurationModel[] = [];

  isScheduleTimeDataLoaded = false;
  isAppointmentDataLoaded = false;
  isAppointmentOpen = false;
  isLoading: boolean = false;
  tdoDateRange: string = '';
  allDocsList: DoctorDataModel[] = [];
  docslist: any[] = [];
  referringdocslist: any[] = [];
  appointments: DataAppointmentModel[];
  isPopupVisible: boolean = false;
  isBusy: boolean = false;
  selectedAppt: any;
  enumApptTypes: EnumValidValueItemModel[];
  appointmentFlagEnums: EnumValidValueItemModel[];
  patientFlagEnums: EnumValidValueItemModel[];
  toothSurfaceEnums: EnumValidValueItemModel[] = [];

  procedures: CaseProcedureConfigurationModel[];
  SearchFor: any;
  SearchForSelectedRowKeys: any[];
  SearchForSelected: string;
  todayButtonAdded: boolean = false;
  currentLOCID: string = '';
  selectedLocIds: string[] = [];
  selectedLocations: ClientLocationDataModel[] = [];

  loadingMedicalInformationForm: boolean = false;
  medicalInformationFormId: string;
  selectedTeeth: ToothUiManagerModel[] = [];

  vcBaseURL = '';

  cellClassName = '.dx-scheduler-date-table-cell';

  rightClickScheduleOptions = [];
  // { ctxId: 3, text: "Reschedule Appointment" },
  rightClickAppointmentOptions = [
    { ctxId: 1, text: 'Edit' },
    { ctxId: 2, text: 'Cancel Appointment' },
    { ctxId: 4, text: 'Open Patient' },
    { ctxId: 5, text: 'Check In' }];
  selectedCellData = {
    StartDate: '',
    EndDate: '',
    Resource_OperatoryId: '',
    enumApptTypeId: '',
    enumApptStatusId: '',
    CaseProcedureId: ''
  };

  currentDateAndTime: Date;
  minEndDateAndTime: Date;
  maxStartDateAndTime: Date;

  isSelectionStarted = false;
  target: any;
  selectedRangeStartDate: any;
  selectedRangeEndDate: any;
  selectedOperatory: any;

  isCellContextMenuVisible = false;
  isAppContextMenuVisible = false;
  isTodayAppointment: boolean = false;
  todayDate: moment.Moment = moment();

  procedureTabOptions: any[] = [];

  // Config settings
  //////////////////////////////////////////////////////////////////////////
  currentLocationScheduleTimes: ScheduleTimesModel;
  colorSchemes: ColorSchemeDataModel[];
  visibleStartHour: number;
  visibleEndHour: number;
  cellDuration = 15;
  visibleTimeBackgroundColor;
  workHoursBackgroundColor;
  isAppointmentClick: boolean = false;
  contextMenuItems: ContextMenuItem[] = [];

  private nonWorkingDays: NonWorkingDayModel[];
  private scheduledWorkDayNumbers: number[] = [];
  private nonScheduledWeekdayNumbers: number[] = [];
  private enumDataReadySubscription: Subscription;
  selectedPatientCases: PatientCaseViewDataModel[] = [];

  private scheduleTimes: ScheduleTimesModel[] = [];
  private appointmentDialogData: AppointmentDialogDataModel = new AppointmentDialogDataModel();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.triggerChangeDetection();
  }

  constructor(
    public dialog: MatDialog,
    private dialogService: DialogService,
    private flagService: FlagsService,
    public signalrService: SignalrService,
    private schedulingService: SchedulingService,
    private doctorsService: DoctorsService,
    private userService: UserService,
    private snackBar: MatSnackBar,
    public globals: Globals,
    private formService: FormsService,
    private scheduleTimeService: ScheduleTimeService,
    private colorSchemeTimeService: ColorSchemesService,
    private staticDataService: StaticDataService,
    private nonWorkingDayService: NonWorkingDaysService,
    private cd: ChangeDetectorRef,
    private landingPageService: LandingPageService,
    private patientService: PatientService,
    private messagingService: MessagingService,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.myControl = new UntypedFormControl('', [Validators.required]);

    this.currentLOCID = globals.LOCID;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.operatoryDataModels) {
      this.appointmentDialogData.operatories = changes.operatoryDataModels.currentValue;
    }
  }

  ngOnInit() {
    const doctorQueryModel = new DoctorQueryOptionsModel();
    doctorQueryModel.isLazyLoad = false;
    doctorQueryModel.isIncludeTdo=true;
    doctorQueryModel.isIncludeReferring=true;   // zoli  was false
    this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {
      this.allDocsList = allDoctors;
    });

    this.setVCBaseUrl();
    this.setCurrentDateAndTime();

    this.signalrService.messageUser.subscribe((messageModel) => {
      switch (messageModel.messageType) {
        case 'CALENDAR_UPDATED':
          if (messageModel.message['actingUserId'] !== this.authService.currentUserValue.authdata.userid) {
            this.getCommonCalendarData();
            this.getLocationScheduleData();
            this.triggerChangeDetection();
          }
          break;
        case 'APPOINTMENT_RESERVED':
          const reserve = messageModel.message['appointment'] as DataAppointmentModel;
          const userId = messageModel.message['userId'] as string;
          const exists = this.appointments.find(p => p.AppointmentId.toLowerCase() === reserve.AppointmentId.toLowerCase());
          if (!exists && this.authService.currentUserValue.authdata.userid.toLowerCase() !== userId.toLowerCase()) {
            const idx1 = this.appointments.findIndex(p => p.AppointmentId.toLowerCase() === reserve.AppointmentId.toLowerCase());
            if (idx1 === -1) {
              this.appointments.push(reserve);
            } else {
              this.appointments[idx1] = reserve;
            }
          }
          this.mapAppointmentsAdditionalOperatories();
          this.triggerChangeDetection();
          break;
        case 'APPOINTMENT_RESERVATION_CANCEL':
          const appointmentId = messageModel.message.toString();
          const appts = this.appointments.filter(p => p.AppointmentId.toLowerCase() === appointmentId.toLowerCase());
          for (const appt of appts) {
            const idx = this.appointments.findIndex(p => p.AppointmentId.toLowerCase() === appointmentId.toLowerCase() && p.Resource_OperatoryId.toLowerCase() === appt.Resource_OperatoryId.toLowerCase());
            if (idx > -1) {
              this.appointments.splice(idx, 1);
            }
          }
          this.triggerChangeDetection();
          break;
        case 'APPOINTMENT_ADDITIONAL_OPS_RESERVED':
          const additionalOps = messageModel.message['newDataApptOps'] as AppointmentOperatoryDataModel[];
          for (const op of additionalOps) {
            const appt = this.appointments.find(p => p.AppointmentId.toLowerCase() === op.AppointmentId.toLowerCase());
            if (appt) {
              const exists1 = appt.dataAppoitmentOperatories.find(p => p.OperatoryId.toLowerCase() === op.OperatoryId.toLowerCase());
              if (!exists1) {
                appt.dataAppoitmentOperatories.push(op);
              }
            }
          }
          this.mapAppointmentsAdditionalOperatories();
          this.triggerChangeDetection();
          break;
      }
    });

    if (!this.staticDataService.isReady) {
      this.enumDataReadySubscription = this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.enumDataReadySubscription.unsubscribe();
          this.setupValidValues();
          this.getCommonCalendarData();
          this.getCommonScheduleData();
        }
      });
    } else {
      this.setupValidValues();
      this.getCommonCalendarData();
      this.getCommonScheduleData();
    }
  }

  ngAfterViewInit(): void {
    this.appointmentDialogDataForWaitList.emit(this.appointmentDialogData);
  }

  triggerChangeDetection() {
    // this.cd.markForCheck();
    this.cd.detectChanges();
  }

  setNewLocations(locations: ClientLocationDataModel[]) {
    const ivl = setInterval(() => {
      if (!this.procedures || !this.docslist) {
        return;
      }

      clearInterval(ivl);
      this.docslist = null;
      if (locations[0])
        this.selectedLocIds = locations.map(p => p.LOCID.toString());
      else
        this.selectedLocIds = [];
      this.selectedLocations = locations;
      this.currentLOCID = this.selectedLocIds[0];

      if (this.staticDataService.isReady) {
        this.getLocationScheduleData();
      } else {
        this.staticDataService.validValuesReadyEvent.subscribe({
          complete: () => this.getLocationScheduleData()
        });
      }
    }, 100);
  }

  getCommonCalendarData() {
    this.isBusy = true;

    if (!this.procedures && !this.allDocsList) {
      this.isAppointmentDataLoaded = false;
    }

    if (!this.tdoCurrentDate) {
      this.tdoCurrentDate = new Date();
    }

    const referringDoctorQueryModel = new DoctorQueryOptionsModel();
    referringDoctorQueryModel.isIncludeTdo = true;
    referringDoctorQueryModel.isIncludeReferring = true;

    const initPromises = [
      // TODO: Probably need all procedures since the CASE tab is not limited to appointment procedures like consults.
      this.schedulingService.getProcedureGroup('AA000001-0000-0000-0000-000000000001').toPromise(),
      this.doctorsService.getDoctors(referringDoctorQueryModel).toPromise(),
    ];

    Promise.all(initPromises).then((results: any[]) => {
      const dataProcedures = results[0];
      const dataRefDoctors: DoctorDataModel[] = results[1];

      // setup procedures
      this.procedures = dataProcedures;
      this.appointmentDialogData.procedures = dataProcedures;
      this.appointmentDialogData.operatories = this.operatoryDataModels;

      this.userService.getUsers(this.globals.TDOCID).subscribe((res) => {
        this.users = res;
        this.appointmentDialogData.users = res;
      });

      // setup ref doctors
      this.referringdocslist = dataRefDoctors.map((p) => {
        return {
          DoctorId: p?.DoctorId,
          ContactId: p.ContactId,
          FirstName: p.dataContact.FirstName,
          LastName: p.dataContact.LastName,
          AKA: p.dataContact.AKA,
          DoctorColor: 'lightblue',
          Description: p.dataContact.FirstName + ' ' + p.dataContact.LastName
        };
      });

      this.isBusy = false;

    }, err => {
      this.isBusy = false;
      this.sendMessage('Error loading appointments', 'Error');
    });
  }

  getDoctors(isGetAllDoctors: boolean) {
    const doctorQueryModel = new DoctorQueryOptionsModel();
    doctorQueryModel.isLazyLoad = false;
    doctorQueryModel.isActiveOnly = true;

    if (isGetAllDoctors) {
      this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {
        this.docslist = allDoctors.map((p) => {
          return {
            UserId: p.UserId,
            DoctorId: p?.DoctorId,
            ContactId: p.ContactId,
            FirstName: p.dataContact.FirstName,
            LastName: p.dataContact.LastName,
            AKA: p.dataContact.AKA,
            DoctorColor: 'lightblue',
            Description: p.dataContact.FirstName + ' ' + p.dataContact.LastName
          };
        });
      });
    } else {
      doctorQueryModel.LOCID = parseInt(this.currentLOCID);
      this.doctorsService.getDoctorsForDoctorLocation(doctorQueryModel).subscribe((locationDoctors) => {
        this.docslist = locationDoctors;
      });
    }
  }

  private getCommonScheduleData() {
    if (!this.colorSchemes) {
      this.isScheduleTimeDataLoaded = false;
    }
    this.nonWorkingDayService.getScheduleNonWorkingRegions().subscribe((regions) => {
      const region = regions.find(p => p.RegionName === 'United States');
      if (region) {
        this.nonWorkingDayService.getScheduleNonWorking(region.WorkRegionID).subscribe((days) => {
          this.nonWorkingDays = days.cfgScheduleNonWorkingDays.filter(p => p.NonWorkingYear === new Date(Date.now()).getFullYear());
        });
        this.triggerChangeDetection();
      }

      this.colorSchemeTimeService.getColorSchemes().subscribe((colorSchemeData) => {
        this.colorSchemes = colorSchemeData;
        this.isScheduleTimeDataLoaded = true;
      });
    });
  }

  private getLocationScheduleData() {
    if (!this.appointments) {
      this.isAppointmentDataLoaded = false;
    }
    this.isLoading = true;
    const appointmentSearchDateRange = this.formatDate(this.tdoCurrentDate) + ' ' + this.formatDate(this.tdoCurrentDate);
    const sched = this.scheduleTimes.find(p => p.locationId.toString() === this.currentLOCID);
    this.docslist = null;
    this.getDoctors(false);
    if (!sched) {
      this.scheduleTimeService.getSchedule(parseInt(this.currentLOCID)).subscribe((data) => {
        // TODO: Start day and end day hour must be on the hour / May need to adjust config selection
        this.currentLocationScheduleTimes = data;
        this.scheduleTimes.push(data);
        this.setScheduleSettings();
        this.appointmentDialogData.timeIncrement = this.currentLocationScheduleTimes.scheduleTime.SchedulerTimeIncrement;

        this.schedulingService.getAppointments(this.selectedLocIds, appointmentSearchDateRange).subscribe((res) => {
          this.appointments = res;
          /*for (const appt of this.appointments) {
            appt.StartDate = new Date(appt.StartDate + 'Z');
            appt.EndDate = new Date(appt.EndDate + 'Z');
          }*/
          this.mapAppointmentProcedures();
          this.mapAppointmentsAdditionalOperatories();
          this.procedures = this.procedures.sort((a, b) => {
            if (a.ProcedureName < b.ProcedureName) {
              return -1;
            } else if (a.ProcedureName > b.ProcedureName) {
              return 1;
            } else {
              return 0;
            }
          });
          this.isAppointmentDataLoaded = true;
          this.isLoading = false;
          this.triggerChangeDetection();
        });

        this.triggerChangeDetection();
      });
    } else {
      this.currentLocationScheduleTimes = sched;
      this.setScheduleSettings();
      this.schedulingService.getAppointments(this.selectedLocIds, appointmentSearchDateRange).subscribe((res) => {
        this.appointments = res;
        this.mapAppointmentProcedures();
        this.mapAppointmentsAdditionalOperatories();
        this.procedures = this.procedures.sort((a, b) => {
          if (a.ProcedureName < b.ProcedureName) {
            return -1;
          } else if (a.ProcedureName > b.ProcedureName) {
            return 1;
          } else {
            return 0;
          }
        });
        this.isAppointmentDataLoaded = true;
        this.isLoading = false;
        this.triggerChangeDetection();
      });
      this.triggerChangeDetection();
    }
    /*setInterval(() => {
      this.triggerChangeDetection();
    }, 500);*/
  }

  private setScheduleSettings() {
    if (this.currentLocationScheduleTimes.scheduleTime.VisibleStartTime) {
      this.visibleStartHour = ConversionUtilities.createDateFromTimeSpan(this.currentLocationScheduleTimes.scheduleTime.VisibleStartTime).getHours();
    } else {

    }

    if (this.currentLocationScheduleTimes.scheduleTime.VisibleEndTime) {
      this.visibleEndHour = ConversionUtilities.createDateFromTimeSpan(this.currentLocationScheduleTimes.scheduleTime.VisibleEndTime).getHours();
    } else {

    }

    if (this.colorSchemes) {
      this.setColorSchemes();
    } else {
      const ivl = setInterval(() => {
        if (this.colorSchemes) {
          clearInterval(ivl);
          this.setColorSchemes();
        }
      }, 100);
    }

    this.scheduledWorkDayNumbers = [];
    this.nonScheduledWeekdayNumbers = [];
    for (const mod of this.currentLocationScheduleTimes.scheduleTimesDays) {
      const modDayNum = this.getDayNumFromValidValueId(mod.enumWeekDaysID);
      if (!this.scheduledWorkDayNumbers.includes(modDayNum)) {
        this.scheduledWorkDayNumbers.push(modDayNum);
      }
    }
    // Figure out which days ARE NOT scheduled for work
    const dayNumbersInWeek = [0, 1, 2, 3, 4, 5, 6];
    for (const dayNum of dayNumbersInWeek) {
      if (!this.scheduledWorkDayNumbers.includes(dayNum)) {
        this.nonScheduledWeekdayNumbers.push(dayNum);
      }
    }

    this.cellDuration = this.currentLocationScheduleTimes.scheduleTime.SchedulerTimeIncrement;
  }

  private setColorSchemes() {
    const visColorScheme = this.colorSchemes.find(p => p.ColorSchemeId === this.currentLocationScheduleTimes.scheduleTime.NonWorkingHoursColorSchemeID);
    if (visColorScheme) {
      this.visibleTimeBackgroundColor = visColorScheme.BackColor;
    }

    const workingHoursColorScheme = this.colorSchemes.find(p =>
      p.ColorSchemeId === this.currentLocationScheduleTimes.scheduleTime.WorkingHoursColorSchemeID);
    if (workingHoursColorScheme) {
      this.workHoursBackgroundColor = workingHoursColorScheme.BackColor;
    }

    this.triggerChangeDetection();
  }

  private setupValidValues(): void {
    this.enumApptTypes = this.staticDataService.getValidValueItemsByValidValueName('enumApptType');
    this.appointmentFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAppoitmentFlag');
    this.patientFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumPatientFlag');
    this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
  }



  setVCBaseUrl() {
    const app = 'vc';
    const origin: string = window.origin;

    if (origin.indexOf('localhost') > -1) {
      return origin;
    }

    const originArr = origin.split('.');
    originArr[0] += `-${app}`;
    this.vcBaseURL = originArr.join('.');
  }

  setCurrentDateAndTime() {
    const now = new Date();
    const currentHours = now.getHours();
    let currentMinutes = now.getMinutes();

    if (currentMinutes === 0) {
      // do nothing
    } else if (currentMinutes < 15) {
      currentMinutes = 0;
    } else if (currentMinutes < 30) {
      currentMinutes = 15;
    } else if (currentMinutes < 45) {
      currentMinutes = 30;
    } else {
      currentMinutes = 45;
    }

    this.currentDateAndTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHours, currentMinutes);
    this.maxStartDateAndTime = new Date(this.selectedCellData.EndDate);
    this.minEndDateAndTime = new Date(this.selectedCellData.StartDate);

  }

  ctxMenuItemClickCell(e) {
        this.isCellContextMenuVisible = false;
        const formattedDate = formatDate(new Date(this.tdoScheduler.selectedCellData[0].startDate), 'M-d-yyyy HH:mm', 'en_US');
        this.schedulingService.rescheduleAppointment(formattedDate, this.globals.RescheduleAppointmentRequest.AppointmentId, this.tdoScheduler.selectedCellData[0].groups.Resource_OperatoryId).subscribe(appt => {
          if (appt){
            this.globals.RescheduleAppointmentRequest = null;
            this.appointments.push(appt);
            this.showCustomPopup(appt);
          }
    });
  }

  ctxMenuItemClickApp(e) {
    this.triggerChangeDetection();

    this.tdoScheduler.selectedCellData = [];
    this.tdoScheduler.selectedCellData.push({ startDate: this.selectedCellData.StartDate, endDate: this.selectedCellData.EndDate, groups: { Resource_OperatoryId: this.selectedCellData.Resource_OperatoryId } });
    this.selectedAppt = JSON.parse(JSON.stringify(this.selectedCellData));
    let patientName;
    const patient = JSON.parse(this.selectedAppt?.PatientFullInfo);
    if (patient) {
      patientName = `${patient.FirstName} ${patient.LastName}`;
    }

    this.isAppContextMenuVisible = false;
    switch (e.itemData.ctxId) {
      case 1:
        this.onAppointmentFormOpening(e);
        break;
      case 2:
        // cancel

        /*this.onAppointmentFormOpening(e, true, enumStatusCanceled);*/
        //this.selectedAppt.enumApptStatusId = ApptStatusEnum.Canceled;


        //CHANGE TO CANCEL WITH DIALOG
        this.appointmentDialogData.cancellingAppointment = true;

        this.appointmentDialogData.appointment = this.selectedAppt;
        this.appointmentDialogData.currentLocationId = this.currentLOCID;
        const cancelConfig = new MatDialogConfig();
        cancelConfig.panelClass = 'dialog';
        cancelConfig.data = this.appointmentDialogData;
        cancelConfig.disableClose = true;
        this.dialog.open(AppointmentDialogComponent, cancelConfig).afterClosed().subscribe((res1) => {
          this.selectedCellData = { StartDate: '', EndDate: '', Resource_OperatoryId: '', enumApptTypeId: '', enumApptStatusId: '', CaseProcedureId: '' };

          this.appointmentDialogData.cancellingAppointment = false;
          if (!res1) {
            this.mapAppointmentProcedures();
            this.selectedAppt = null;
          } else {
            this.schedulingService.cancelAppointment(this.selectedAppt.AppointmentId).subscribe((res) => {

              const appts = this.appointments.filter(p => p.AppointmentId.toLowerCase() === res.AppointmentId.toLowerCase());
              for (const appt of appts) {
                const idx = this.appointments.findIndex(p => p.AppointmentId.toLowerCase() === res.AppointmentId.toLowerCase() && p.Resource_OperatoryId.toLowerCase() === appt.Resource_OperatoryId.toLowerCase());
                if (res.xauditDeleted) {
                  if (idx > -1) {
                    this.appointments.splice(idx, 1);
                  }
                } else {
                  if (!this.selectedAppt.isDuplicateForSecondaryOps) {
                    this.appointments[idx] = res;
                  }

                }
              }
            },
              (err) => {
                console.log("Error on subscribe", err);
                this.sendMessage('Something went wrong: ' + err.error?.ExceptionMessage, 'Error');
                this.selectedAppt = null;
                this.appointmentDialogData.appointment = null;
                return;
              },
              () => {

                this.mapAppointmentsAdditionalOperatories();
                this.triggerChangeDetection();
                this.selectedAppt = null;
                setTimeout(() => {
                  this.appointmentDialogData.appointment = null;
                }, 200);
                this.isAppointmentOpen = false;
              }
            );
          }


        },
          (err) => {
            console.log("Error on subscribe", err);
          }
        );

        //// CHANGE TO DIALOG CANCEL END

        break;
      case 3:
        // Reschedule
        // var enumStatusReschedule: string = '00000072-0000-0000-0000-000000000007';
        // onAppointmentFormOpening(e, true, '');
        break;
      case 4: // Open patient
        this.changeToPatientAndGotoCaseView(this.selectedAppt);
        //this.launchPatientDetails();
        break;
      case 5: // Check in
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.selectedAppt;
        this.dialog.open(PatientCheckinDialogComponent, config).afterClosed().subscribe((res) => {
          if (res) {
            const appointmentSearchDateRange = this.formatDate(this.tdoCurrentDate) + ' ' + this.formatDate(this.tdoCurrentDate);
            this.schedulingService.getAppointments(this.selectedLocIds, appointmentSearchDateRange).subscribe((res1) => {
              this.appointments = res1;
              this.mapAppointmentProcedures();
              this.mapAppointmentsAdditionalOperatories();
              this.triggerChangeDetection();
            });
          }
        });
        break;
      case 6:  // Check out
        localStorage.setItem('selectedAppt', JSON.stringify(this.selectedAppt));
        this.messagingService.sendParentMessage(MessagingConstants.PATIENT_CHANGED, {
          PatientID: patient.PatientId,
          PatientName: patientName,
          Process: MessagingConstants.CHECKOUT_PATIENT_START,
          PatientCaseId: this.selectedAppt.PatientCaseId
        });
        break;
        case 7:  // Cancel Reservation
        this.schedulingService.deleteAppointment(this.selectedAppt.AppointmentId).subscribe((res) => {
          const idx = this.appointments?.findIndex(p => p.AppointmentId.toLowerCase() === this.selectedAppt?.AppointmentId.toLowerCase());
          if (idx > -1) {
            this.appointments.splice(idx, 1);
            this.mapAppointmentProcedures();
            this.mapAppointmentsAdditionalOperatories();
          }
          this.triggerChangeDetection();
        });
        break;
        case 8: { // Confirm
        this.appointmentDialogData.confirmingAppointment = true;
        this.selectedAppt.enumApptStatusId = ApptStatusEnum.Confirmed;
        this.appointmentDialogData.appointment = this.selectedAppt;
        this.appointmentDialogData.currentLocationId = this.currentLOCID;
        const confirmConfig = new MatDialogConfig();
        confirmConfig.panelClass = 'dialog';
        confirmConfig.data = this.appointmentDialogData;
        confirmConfig.disableClose = true;
        this.dialog.open(AppointmentDialogComponent, confirmConfig).afterClosed().subscribe((res1) => {
          this.appointmentDialogData.confirmingAppointment = false;
          if (!res1) {
            this.mapAppointmentProcedures();
            this.selectedAppt = null;
          } else {
            const appts = this.appointments.filter(p => p.AppointmentId.toLowerCase() === res1.AppointmentId.toLowerCase());
            for (const appt of appts) {
              const idx = this.appointments.findIndex(p => p.AppointmentId.toLowerCase() === res1.AppointmentId.toLowerCase() && p.Resource_OperatoryId.toLowerCase() === appt.Resource_OperatoryId.toLowerCase());
                if (idx > -1) {
                  this.appointments[idx] = res1;
              } else {
                if (!this.selectedAppt.isDuplicateForSecondaryOps) {
                  this.appointments[idx] = res1;
                }

              }
            }
            this.sendMessage('Appointment successfully confirmed !', 'Appointment');
          }
        },
          (err) => {
            console.log("Error on subscribe", err);
          }
        );

        break;
      }
      default:
      // code block
    }
  }

  onAppointmentClick(e) {
    // this.selectedAppt = JSON.parse(JSON.stringify(e.appointmentData));
    // this.selectedAppt.text = '*';
    this.isAppointmentClick = true;
  }

  onCellClick($event: any) {
    this.isAppointmentClick = false;
  }

  downHandler(e) {
    const el = $(e.target);
    if (el.hasClass('dx-scheduler-date-table-cell')) {
      this.isSelectionStarted = true;
      this.target = e.target;
    }
  }

  onAppointmentUpdatedDragDrop(e) {
    this.selectedAppt = JSON.parse(JSON.stringify(e.appointmentData));
    // this.showCustomPopup(this.selectedAppt);
    this.onSaveAppointments(e);
  }

  onContentReady(e) {
    this.isTodayAppointment = false;
    /*e.element.querySelectorAll('.dx-scheduler-date-table-cell').forEach(el => {
      events.on(el, 'dxcontextmenu', (event) => {
        if(e.component.getWorkSpace().getCellData([event.target]) !== undefined) {
          this.selectedCellData = e.component.getWorkSpace().getCellData([event.target]);
        }
        //this.selectedCellData = e.component.getAppointmentsInstance()._getItemData(event.target.closest('.dx-item'));

      });
    });*/
    e.element.querySelectorAll('.dx-scheduler-appointment-content').forEach(el => {
      events.on(el, 'dxcontextmenu', (event) => {
        this.selectedCellData = e.component.getAppointmentsInstance()._getItemData(event.target.closest('.dx-item'));

      });
    });

    if (!this.todayButtonAdded) {
      const self: any = this;
      const element = document.querySelectorAll('.dx-scheduler-navigator');
      const container = document.createElement('div');
      element[0].appendChild(container);

      // tslint:disable-next-line:no-unused-expression
      new Button(container, {
        text: 'Today',
        onClick() {
          this.isBusy = true;

          this.tdocurrentDate = new Date();
          self.tdoScheduler.instance.option('currentDate', this.tdocurrentDate);
        }
      });

      this.todayButtonAdded = true;
    }
    //this.triggerChangeDetection();
  }

  onSaveAppointments(e) {
    if (e === 'save') {
      // console.log("Save OK click ...");
    }
    else {
      if (!(this.selectedAppt.text === '*')) {
        if (this.selectedAppt.text === 'Saved') {
          this.selectedAppt.text = '*';
          return;
        }
      }
    }

    this.isBusy = true;

    let validationError = '';
    if (this.selectedAppt.PatientId === undefined) {
      validationError += 'Please select a patient!\r\n';
    }

    /*if (this.selectedAppt.CaseProcedureId === null || this.selectedAppt.CaseProcedureId === undefined ||
      this.selectedAppt.CaseProcedureId === '') {
      validationError += 'Please select a Procedure!\r\n';
    }*/

    if (this.selectedAppt.Label_DoctorId === null || this.selectedAppt.Label_DoctorId === undefined) {
      validationError += 'Please select a Doctor!\r\n';
    }

    if (this.selectedAppt.enumApptTypeId === null || this.selectedAppt.enumApptTypeId === undefined) {
      validationError += 'Please select a Type!\r\n';
    }

    if (validationError !== '') {
      alert('Validation Error on  Appointment!\r\n' + validationError);
      this.isBusy = false;
      return;
    }

    const selectedAppId = this.selectedAppt.AppointmentId;

    this.schedulingService.addAppointment(this.selectedAppt, this.selectedTeeth)
      .subscribe((dataAppointment) => {
        const dataAppointmentId = dataAppointment.AppointmentId;

        if (dataAppointmentId === selectedAppId) {
          // appoitment updated
          // no need for action
          const appointmentIndex = this.appointments.findIndex(appt => {
            return appt.AppointmentId === dataAppointmentId;
          });

          if (appointmentIndex > -1) {
            this.appointments.splice(appointmentIndex, 1);
          }

          this.appointments.push(dataAppointment);
          this.mapAppointmentProcedures();
          this.procedures = this.procedures.sort((a, b) => {
            if (a.ProcedureName < b.ProcedureName) {
              return -1;
            } else if (a.ProcedureName > b.ProcedureName) {
              return 1;
            } else {
              return 0;
            }
          });
          this.triggerChangeDetection();
        }
        else {
          this.selectedAppt.AppointmentId = selectedAppId;

          if (this.appointments == null) {
            this.appointments = [dataAppointment];
          } else {
            this.appointments.push(dataAppointment);
            this.triggerChangeDetection();
          }

          this.mapAppointmentProcedures();
          this.procedures = this.procedures.sort((a, b) => {
            if (a.ProcedureName < b.ProcedureName) {
              return -1;
            } else if (a.ProcedureName > b.ProcedureName) {
              return 1;
            } else {
              return 0;
            }
          });
        }

        /*if (this.simpleNote?.note?.Note && this.simpleNote?.note?.Note?.length > 0) {
          this.simpleNote.saveAppointmentNote(dataAppointment.PatientCaseId, dataAppointment.CaseProcedureId, dataAppointment.AppointmentId);
        }*/

        this.selectedAppt.isNewApt = false;
        this.tdoScheduler.instance.updateAppointment(this.selectedAppt, { text: 'Saved' });
        this.isBusy = false;
        this.isPopupVisible = false;

        this.selectedRangeStartDate = null;
        this.tdoScheduler.selectedCellData.slice(0, this.tdoScheduler.selectedCellData.length);
        this.selectedAppt = null;
        this.triggerChangeDetection();
      }, (error) => {
        console.log('Error Saving Appointment Data ');
        console.log(error);
        this.isBusy = false;
        alert('Error Saving Appointment!');
      });

  }


  onCellContextMenu(event: any) {
    if(this.globals.RescheduleAppointmentRequest !== null) {
      const startDate = event.cellData.startDate;
      const endDate = event.cellData.endDate;
      this.tdoScheduler.selectedCellData = [];
      this.tdoScheduler.selectedCellData.push({ startDate, endDate, groups: { Resource_OperatoryId: event.cellData.groups.Resource_OperatoryId } });
      this.target = this.cellClassName;
      this.rightClickScheduleOptions = [
        {
          ctxId: 1,
          text: 'Paste Reschedule'
        },
      ];
    }
    else{
      this.rightClickScheduleOptions = [];
    }
  }

  onViewDateOptionChanged(e) {
    if (e.fullName === 'currentDate') {
      this.tdoCurrentDate = e.value;
      this.tdoDateRange = this.formatDate(e.value) + ' ' + this.formatDate(e.value);
      this.loadAppointments(this.tdoDateRange);
    }

    if (e.fullName === 'currentView') {

      if (e.value === 'day') {
        this.tdoDateRange = this.formatDate(this.tdoCurrentDate) + ' ' + this.formatDate(this.tdoCurrentDate);
      }

      if (e.value === 'week' || e.value === 'workWeek') {
        const ms = e.component.getStartViewDate().getTime(); // one day = 86400000ms;
        const d1 = new Date(ms - 86400000 * 7);
        const d2 = new Date(ms + 86400000 * 7);
        this.tdoDateRange = this.formatDate(d1) + ' ' + this.formatDate(d2);
      }

      if (e.value === 'month') {
        const ms = e.component.getStartViewDate().getTime(); // one day = 86400000ms;
        const d1 = new Date(ms - 86400000 * 30);
        const d2 = new Date(ms + 86400000 * 30);
        this.tdoDateRange = this.formatDate(d1) + ' ' + this.formatDate(d2);
      }

      this.loadAppointments(this.tdoDateRange);
    }
  }

  mapAppointmentProcedures() {
    if (!this.appointments || !this.procedures) {
      return;
    }

    this.appointments.forEach(appt => {
      if (!appt.Procedure) {
        appt.Procedure = this.procedures.find(proc => {
          return proc.CaseProcedureId === appt.CaseProcedureId;
        });

        if (appt?.Procedure?.ProcedureName === 'Description:') {
          appt.Procedure.ProcedureName = 'No procedure selected';
        }

        if (appt?.Procedure?.Description === 'Description:') {
          appt.Procedure.Description = 'No procedure selected';
        }

        if (!appt.Procedure) {
          appt.Procedure = new CaseProcedureConfigurationModel();
        }
      }
    });
  }

  loadAppointments(dateRange: string) {
    // this.isBusy = true;
    this.schedulingService.getAppointments(this.selectedLocIds, dateRange).subscribe(dataC => {
      this.appointments = dataC;
      this.mapAppointmentProcedures();
      this.mapAppointmentsAdditionalOperatories();
      this.triggerChangeDetection();
      this.isBusy = false;
    },
      (error) => {
        this.sendMessage('Something went wrong', 'Error');
        console.log('calerror: ' + error);
        this.isBusy = false;
      });
  }

  mapAppointmentsAdditionalOperatories() {
    this.appointments = this.appointments.filter(p => !p.isDuplicateForSecondaryOps);
    const appts = this.appointments.concat();
    for (const appt of appts) {
      appt.isDuplicateForSecondaryOps = false;
      const additional = appt.dataAppoitmentOperatories.filter(p => !p.isPrimary && p.xauditDeleted !== true);
      for (const add of additional) {
        const exists = this.appointments.find(p => p.AppointmentId.toLowerCase() === appt.AppointmentId.toLowerCase() && p.Resource_OperatoryId.toLowerCase() === add.OperatoryId);
        if (!exists) {
          const clone = { ...appt } as DataAppointmentModel;
          clone.Resource_OperatoryId = add.OperatoryId;
          clone.isDuplicateForSecondaryOps = true;
          clone.parentAppointmentId = appt.AppointmentId;
          this.appointments.push(clone);
        } else {
          /*if (!add.isPrimary) {
            appt.isDuplicateForSecondaryOps = true;
          }*/
        }
      }
    }

    this.triggerChangeDetection();
  }

  formatDate(date) {
    // tslint:disable-next-line:one-variable-per-declaration prefer-const
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      // tslint:disable-next-line:prefer-const
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  async getMedicalInformationFormForPatient(patientId) {
    this.loadingMedicalInformationForm = true;
    this.medicalInformationFormId = '';

    this.formService.getMedicalInformationFormForPatient(patientId)
      .subscribe(response => {
        this.medicalInformationFormId = response;
        this.loadingMedicalInformationForm = false;
        this.triggerChangeDetection();
      }, err => {
        console.log('error getting medical information');
        this.loadingMedicalInformationForm = false;
        this.triggerChangeDetection();
      });

  }

  loadAppointmentDetails() {
    if (!this.selectedAppt.dataAppoitmentDetails) {
      return;
    }

    // loop through details to find information
    const detailsToLoad: string[] = [
      'Referring_DoctorId', 'needToConfirmApp', 'calledLeftMsg', 'earlierAppIfPossible', 'needPremed', 'sendSMS', 'sendEmail',
    ];

    detailsToLoad.forEach(detailKey => {

      const detailData = this.selectedAppt.dataAppoitmentDetails.find(detail => {
        return detail.DetailParameterName === detailKey;
      });

      if (detailData) {
        this.selectedAppt[detailKey] = detailData.DetailParameterValue;
        if (this.selectedAppt[detailKey] === 'True') {
          this.selectedAppt[detailKey] = true;
        }
        if (this.selectedAppt[detailKey] === 'False') {
          this.selectedAppt[detailKey] = false;
        }
      }
    });
    this.triggerChangeDetection();
  }

  returnDoctorById(doctorId: string): DoctorDataModel {
    if (!this.allDocsList) {
      return;
    }
    const foundDoctor = this.allDocsList.find(doctor => {
      return doctorId === doctor?.DoctorId;
    });

    if (foundDoctor) {
      return foundDoctor;
    }
  }

  returnReferringDoctorById(appt: any, doctorId: string) {
    if (!appt) {
      return null;
    }
    const details = appt.dataAppoitmentDetails;
    if (details) {
      const detail = details.find(p => p.DetailParameterName === 'Referring_DoctorId');
      if (detail) {
        const foundDoctor = this.referringdocslist.find(doctor => doctor?.DoctorId?.toLowerCase() === detail.DetailParameterValue);
        if (foundDoctor) {
          // this.triggerChangeDetection();
          return foundDoctor;
        }
      }
    }

    // return { Description: '*' };
  }

  overrideDefaultPopup(event) {
    if (event.appointmentData) {
      let appt = event.appointmentData as DataAppointmentModel;
      event.cancel = true;
      if (appt.parentAppointmentId) {
        appt = this.appointments.find(p => p.AppointmentId.toLowerCase() === appt.parentAppointmentId.toLowerCase());
      }
      this.showCustomPopup(appt);
    }
  }

  sendMessage(message: string, type: string) {
    this.snackBar.open(message, type, {
      duration: type == "Error" ? 10000 : 3000,
      verticalPosition: 'top'
    });
  }

  onAppointmentFormOpening(e, overrideStatus: boolean = false, status: string = '') {
    // this.isAppointmentClick = false;
    e.cancel = true;
    if (this.tdoScheduler.selectedCellData.length) {
      const start = new Date(this.tdoScheduler.selectedCellData[0].startDate.toLocaleString());
      const end = new Date(this.tdoScheduler.selectedCellData[this.tdoScheduler.selectedCellData.length - 1].endDate.toLocaleString());

      // var now = new Date();
      const now = this.currentDateAndTime;

      if (now > start || now > end) {
        // alert the user that they cannot make an appoint before 'now'
        this.sendMessage('Warning.  You are editing a past appointment.', 'Error');

        // return;
      }
    }

    const imax = this.tdoScheduler.selectedCellData.length - 1;
    if (!this.tdoScheduler.selectedCellData[imax].groups) {
      this.sendMessage('Warning. You have not selected an Operatory to assign.', 'Error');
      return;
    }
    this.selectedOperatory = this.tdoScheduler.selectedCellData[imax].groups.Resource_OperatoryId;
    if (this.selectedAppt == null) {
      // create new appointment
      try {
        if (!this.selectedRangeStartDate) {
          this.selectedCellData = { StartDate: '', EndDate: '', Resource_OperatoryId: '', enumApptTypeId: '', enumApptStatusId: '', CaseProcedureId: '' };
          this.selectedCellData.Resource_OperatoryId = this.selectedOperatory;
          this.selectedCellData.StartDate = this.tdoScheduler.selectedCellData[0].startDate.toLocaleString();
          this.selectedCellData.EndDate = this.tdoScheduler.selectedCellData[this.tdoScheduler.selectedCellData.length - 1]
            .endDate.toLocaleString();
        } else {
          this.selectedCellData.Resource_OperatoryId = this.selectedOperatory;
          this.selectedCellData.StartDate = this.selectedRangeStartDate;
          this.selectedCellData.EndDate = this.selectedRangeEndDate;
        }
      }
      catch (ex: any) {
        console.log('test');
      }

      const imax = this.tdoScheduler.selectedCellData.length - 1;
      this.selectedOperatory = this.tdoScheduler.selectedCellData[imax].groups.Resource_OperatoryId;

      this.selectedCellData.enumApptTypeId =  ApptTypeEnum.Scheduled,//'00000071-0000-0000-0000-000000000001';
      this.selectedCellData.enumApptStatusId = ApptStatusEnum.Unconfirmed;
      this.selectedCellData.CaseProcedureId = '';
      this.selectedAppt = JSON.parse(JSON.stringify(this.selectedCellData));
    }
    else{
      this.selectedCellData.Resource_OperatoryId = this.selectedOperatory;
      this.selectedCellData.StartDate = this.tdoScheduler.selectedCellData[0].startDate.toLocaleString();
      this.selectedCellData.EndDate = this.tdoScheduler.selectedCellData[this.tdoScheduler.selectedCellData.length - 1]
        .endDate.toLocaleString();

    }

    this.selectedAppt.LOCID = this.currentLOCID;

    if (overrideStatus) {
      this.selectedAppt.enumApptStatusId = status;
    }
    const appt = this.selectedAppt;
    this.setCurrentDateAndTime();
    e.cancel = true;

    this.showCustomPopup(appt);
    // this.triggerChangeDetection();
  }

  async showCustomPopup(appointment) {

    this.isAppointmentOpen = true;
    this.isAppointmentClick = false;
    this.selectedAppt = appointment;
    this.selectedAppt.isNewApt = false;
    // we need this for fields that will be saved in detail table
    this.selectedAppt.FindPatient = '';
    this.selectedAppt.Referring_DoctorId = '';
    // this.selectedAppt.PatientFullInfo = "";
    this.selectedAppt.needToConfirmApp = false;
    this.selectedAppt.appConfirmed = false;
    this.selectedAppt.calledLeftMsg = false;
    this.selectedAppt.earlierAppIfPossible = false;
    this.selectedAppt.needPremed = false;
    this.selectedAppt.donotshowincalendar = false;

    this.SearchFor = null;
    this.SearchForSelectedRowKeys = [];
    this.SearchForSelected = '';

    if (!this.selectedAppt.AppointmentId) {
      this.selectedAppt.isNewApt = true;
      /// set the new appt message
      // you also have to update this message everytime something is changed
      // make a button to refresh it?

    } else {
      // find items in the details
      this.loadAppointmentDetails();
    }

    // this.isPopupVisible = true;

    if (this.selectedAppt.PatientId) {
      this.getPatientCases(true);
      this.getMedicalInformationFormForPatient(this.selectedAppt.PatientId);
    } else {
      this.loadingMedicalInformationForm = false;
      this.medicalInformationFormId = '';
    }

    this.appointmentDialogData.allDoctors = this.allDocsList;
    this.appointmentDialogData.appointment = this.selectedAppt;


    if (this.selectedAppt.AppointmentId) {
      this.appointmentDialogData.appointment = this.selectedAppt;
      this.appointmentDialogData.currentLocationId = this.currentLOCID;
      const config = new MatDialogConfig();
      config.panelClass = 'dialog';
      config.data = this.appointmentDialogData;
      config.disableClose = true;
      // readonly if app is cancelled
      (this.appointmentDialogData.appointment.enumApptStatusId === ApptStatusEnum.Canceled) ? config.data.isReadOnly = true : config.data.isReadOnly = false;

      this.dialog.open(AppointmentDialogComponent, config).afterClosed().subscribe((res1) => {
        this.selectedCellData = { StartDate: '', EndDate: '', Resource_OperatoryId: '', enumApptTypeId: '', enumApptStatusId: '', CaseProcedureId: '' };
        if (!res1) {
          this.mapAppointmentProcedures();
          this.mapAppointmentsAdditionalOperatories();
        } else {
          const idx = this.appointments.findIndex(p => p.AppointmentId.toLowerCase() === res1.AppointmentId.toLowerCase());
          if (idx > -1) {
            this.appointments[idx] = res1;
            this.mapAppointmentProcedures();
            this.mapAppointmentsAdditionalOperatories();
          }

          if (res1.PatientId) {
            this.flagService.runFlagRoutineForPatient(res1.PatientId, res1.LOCID.toString()).subscribe((res2) => {
              res1.dataPatientFlags = res2;
            });
          }
          this.changeToPatientAndGotoCaseView(res1);
        }
        this.triggerChangeDetection();
        this.selectedAppt = null;
        setTimeout(() => {
          this.appointmentDialogData.appointment = null;
        }, 200);
        this.isAppointmentOpen = false;
      });
    } else {
      const reserve = new DataAppointmentModel();
      reserve.StartDate = appointment.StartDate;
      reserve.EndDate = appointment.EndDate;
      reserve.LOCID = parseInt(this.currentLOCID);
      reserve.Resource_OperatoryId = this.selectedOperatory;
      reserve.Description = '';
      reserve.isReservation = true;
      reserve.dataAppoitmentDetails = [];

      reserve.enumApptStatusId = ApptStatusEnum.Unconfirmed;
      reserve.enumApptTypeId = ApptTypeEnum.Scheduled; //'00000071-0000-0000-0000-000000000001';
      this.schedulingService.reserveAppointmentSlot(reserve).subscribe((res) => {
        this.selectedAppt.AppointmentId = res.AppointmentId;
        this.appointmentDialogData.appointment = res;
        this.appointmentDialogData.currentLocationId = this.currentLOCID;
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.appointmentDialogData;
        config.data.isReadOnly = false;
        config.disableClose = true;
        this.dialog.open(AppointmentDialogComponent, config).afterClosed().subscribe((res1) => {
          this.selectedCellData = { StartDate: '', EndDate: '', Resource_OperatoryId: '', enumApptTypeId: '', enumApptStatusId: '', CaseProcedureId: '' };
          if (!res1) {
            this.schedulingService.deleteAppointment(this.selectedAppt.AppointmentId).subscribe((res2) => {
              const idx = this.appointments?.findIndex(p => p.AppointmentId.toLowerCase() === this.selectedAppt.AppointmentId.toLowerCase());
              if (idx > -1) {
                this.appointments.splice(idx, 1);
                this.mapAppointmentProcedures();
                this.mapAppointmentsAdditionalOperatories();
              }
              this.triggerChangeDetection();
            });
          } else {
            this.appointments.push(res1);
            this.flagService.runFlagRoutineForPatient(res1.PatientId, res1.LOCID.toString()).subscribe((res2) => {
              res1.dataPatientFlags = res2;
            });
            this.changeToPatientAndGotoCaseView(res1);
            this.mapAppointmentProcedures();
            this.mapAppointmentsAdditionalOperatories();
            this.triggerChangeDetection();
            setTimeout(() => {
              this.triggerChangeDetection();
            }, 400);
          }

          this.selectedAppt = null;
          setTimeout(() => {
            this.appointmentDialogData.appointment = null;
          }, 200);
          this.isAppointmentOpen = false;
        });
      });
    }

    // get a new seq GUID
    $('#patSel').ready(_ => {
      const query = '#patSel > div.dx-dropdowneditor-input-wrapper.dx-selectbox-container > div >' +
        'div.dx-texteditor-input-container > input';
      const el = $(query).first();

      // tslint:disable-next-line:no-shadowed-variable
      setTimeout(_ => {
        el.focus();
      }, 500);
    });
    this.triggerChangeDetection();
  }

  onVCCallClick(e: string): void {
    console.log('onVCCallClick', e);
    const vcAppt = JSON.parse(e);
    const url = this.formatLink('vc') + '/' + vcAppt.vcURL;
    window.open(url, '_blank');
  }

  private formatLink(app: string) {
    const origin: string = window.origin;

    if (origin.indexOf('localhost') > -1) {
      return origin;
    }

    const originArr = origin.split('.');
    originArr[0] += `-${app}`;

    const finalURL = originArr.join('.');

    return finalURL;
  }

  launchPatientDetails() {
    const dm = new PatientDialogDataModel();
    dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
    dm.entityType = PatientDialogDataModel.TYPE_PATIENT;
    dm.title = 'Edit Patient';
    //dm.initWebId = true;
    dm.entityId = this.selectedAppt.PatientId;

    const config = new MatDialogConfig();
    config.width = '968px';
    config.height = '600px';
    config.panelClass = 'tdo-note-dialog-main';
    config.data = dm;
    this.isPopupVisible = false;

    const dialogRef = this.dialog.open(PatientEditComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      this.isPopupVisible = true;
      if (result) {
        const patientInfo = JSON.parse(this.selectedAppt.PatientFullInfo);
        patientInfo.FullName = `${result.ThePatient.dataContact.FirstName} ${result.ThePatient.dataContact.LastName}`;
        this.selectedAppt.PatientFullInfo = JSON.stringify(patientInfo);


        this.appointments.forEach(appt => {
          if (appt.AppointmentId === this.selectedAppt.AppointmentId) {
            appt.PatientFullInfo = this.selectedAppt.PatientFullInfo;
          }
        });
      }
      this.triggerChangeDetection();
    }, err => {
      console.log(err);
    });
  }

  private getPatientCases(isExisting = false) {
    this.landingPageService.getPatientsCases4Landing(this.selectedAppt.PatientId).subscribe((res) => {
      this.selectedPatientCases = res;
      this.triggerChangeDetection();
    });
  }

  onOpenMedicalInformationFormDialog(appointmentData: DataAppointmentModel) {
    // ApptMedicalInformation
    console.log('onOpenMedicalInformationFormDialog');
    this.dialogService.openMedicalHistory(appointmentData.PatientId);
  }

  changeToPatientAndGotoCaseView(appointmentData: DataAppointmentModel) {
    if (!this.isBlockAppt(appointmentData)) {
      const jsonobject = JSON.parse(appointmentData.PatientFullInfo);
      const patientName = jsonobject.FirstName + ' ' + jsonobject.LastName;

      this.messagingService.sendParentMessage(MessagingConstants.PATIENT_CHANGED, {
        PatientID: appointmentData.PatientId,
        PatientName: patientName,
        Process: MessagingConstants.RELOAD_SCHEDULE_APPOINTMENTS,
        clearCurrentQuery: false
      });
    }
  }

  onMouseUp(event: MouseEvent) {
    setTimeout(() => {
      if (event.button !== 0 || this.isAppointmentClick) {
        return;
      }
      setTimeout(() => {
        if (this.isAppointmentOpen) {
          return;
        }
        this.onAppointmentFormOpening(event);
      }, 100);
    }, 100);
  }

  getLocationShortName(model: OperatoryDataModel) {
    const loc = this.selectedLocations?.find(p => p.LOCID === model.LOCID);
    if (loc) {
      return loc.LocationShortName;
    }
  }

  stopPropegation($event: MouseEvent) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    $event.preventDefault();
  }

  appointmentMouseDown($event: MouseEvent, dataAppointment: DataAppointmentModel) {
    if (dataAppointment.isReservation) {
      $event.stopPropagation();
      $event.stopImmediatePropagation();
    }
  }

  onAppointmentContext(event: any) {
    this.isAppointmentClick = true;
    if (this.formatDate(new Date(this.selectedCellData.StartDate).toDateString()) === this.formatDate(this.todayDate.format())) {
      this.isTodayAppointment = true;
    }
    if (event.appointmentData.isReservation) {
      // this.rightClickAppointmentOptions = [{ ctxId: 2, text: 'Cancel Appointment' }];
      this.rightClickAppointmentOptions =[];
      if (this.authService.currentUserValue.authdata.userid === event.appointmentData.xauditCreatedBy)
        this.rightClickAppointmentOptions.push({ ctxId: 7, text: 'Cancel Reservation' });
    }
    else if ((this.selectedCellData.enumApptStatusId === ApptStatusEnum.Remote_Checked_In ||
      this.selectedCellData.enumApptStatusId === ApptStatusEnum.Checked_in ||
      this.selectedCellData.enumApptStatusId === ApptStatusEnum.Seated ||
      this.selectedCellData.enumApptStatusId === ApptStatusEnum.ReadyToCheckOut) && this.isTodayAppointment) {
      this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 4, text: 'Open Patient' }, { ctxId: 6, text: 'Check Out' }];
    }
    else if (this.selectedCellData.enumApptStatusId === ApptStatusEnum.Checked_out) {
      this.rightClickAppointmentOptions = [{ ctxId: 4, text: 'Open Patient' }];
    }
    else if (this.selectedCellData.enumApptStatusId === ApptStatusEnum.Canceled) {
      this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 4, text: 'Open Patient' }];
    }
    else if (this.isTodayAppointment) {
      this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 4, text: 'Open Patient' }, { ctxId: 5, text: 'Check In' }];
      if(this.selectedCellData.enumApptStatusId !== ApptStatusEnum.Confirmed){ this.rightClickAppointmentOptions.push({ ctxId: 8, text: 'Confirm' }); }
    }
    else if ((this.selectedCellData.enumApptStatusId !== ApptStatusEnum.Remote_Checked_In &&
      this.selectedCellData.enumApptStatusId !== ApptStatusEnum.Checked_in &&
      this.selectedCellData.enumApptStatusId !== ApptStatusEnum.Seated && this.selectedCellData.enumApptStatusId !== ApptStatusEnum.Checked_out)) {
      this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 4, text: 'Open Patient' }];
      if(this.selectedCellData.enumApptStatusId !== ApptStatusEnum.Confirmed){ this.rightClickAppointmentOptions.push({ ctxId: 8, text: 'Confirm' }); }
    }

  }

  onSelectingCells(event: Array<any>) {
    this.isAppointmentClick = false;
  }


  // VIEW LOGIC FOR THINGS LIKE CELL COLOR, FLAGS, ETC
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * Each cells property is sent in to evaluate start time and associated operatory column
   * @param dataCell cell data containing date objects and associated operatory Id
   */
  getCellBackgroundColor(dataCell) {
    if (!this.currentLocationScheduleTimes || (!this.currentLocationScheduleTimes.scheduleTimesDays)) {
      return;
    }

    const date: Date = dataCell.startDate;
    const cellHour = date.getHours();
    const cellMinute = date.getMinutes();

    let workStartTime;
    let workEndTime;
    const models = this.currentLocationScheduleTimes.scheduleTimesDays.filter(p => this.getDayNumFromValidValueId(p.enumWeekDaysID) === date.getDay());
    if (models && models.length > 0) {
      workStartTime = ConversionUtilities.createDateFromTimeSpan(models[0].StartTime);
      workEndTime = ConversionUtilities.createDateFromTimeSpan(models[models.length - 1].EndTime);

      if (cellHour < workStartTime.getHours()) {
        return this.visibleTimeBackgroundColor;
      } else if (cellHour === workStartTime.getHours()) {
        if (cellMinute < workStartTime.getMinutes()) {
          return this.visibleTimeBackgroundColor;
        }
      }

      if (cellHour > workEndTime.getHours()) {
        return this.visibleTimeBackgroundColor;
      } else if (cellHour === workEndTime.getHours()) {
        if (cellMinute >= workEndTime.getMinutes()) {
          return this.visibleTimeBackgroundColor;
        }
      }
    }

    const blockedColor = this.getOperatoryBlockedOutTimeColor(dataCell);
    if (blockedColor) {
      return blockedColor;
    }
  }

  private getOperatoryBlockedOutTimeColor(dataCell) {
    if (dataCell.groups && dataCell.groups.Resource_OperatoryId) {
      const hours = dataCell.startDate.getHours();
      const minutes = dataCell.startDate.getMinutes();
      const day = dataCell.startDate.getDay();

      const models = this.currentLocationScheduleTimes.scheduleTimeBlockedTimes.filter(p => p.OperatoryID === dataCell.groups.Resource_OperatoryId);
      if (models.length > 0) {
        const blockedDay = this.getDayNumFromValidValueId(models[0].enumWeekDaysID);
        if (blockedDay === day) {
          for (const model of models) {
            const blockedTimeStart = ConversionUtilities.createDateFromTimeSpan(model.StartTime);
            const blockedTimeEnd = ConversionUtilities.createDateFromTimeSpan(model.EndTime);

            const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === model.ColorSchemeID);
            if (hours > blockedTimeStart.getHours() && hours < blockedTimeEnd.getHours()) {
              if (colorScheme) {
                return colorScheme.BackColor;
              }
            } else {
              if (hours === blockedTimeStart.getHours()) {
                if (minutes >= blockedTimeStart.getMinutes()) {
                  return colorScheme?.BackColor;
                }
              } else if (hours === blockedTimeEnd.getHours()) {
                if (minutes < blockedTimeEnd.getMinutes()) {
                  return colorScheme?.BackColor;
                }
              }
            }
          }
        }
      }
    }
    return null;
  }

  /**
   * Checks both days not included in scheduled business hours, and the specifically blocked out days like holiday from configuration.
   * @param date the cell being evaluated date object which holds the hour and minutes of the particular row
   */
  isNonWorkingDay(date: Date) {
    let isNonWorkingDay = false;
    if (!this.nonWorkingDays) {
      return null;
    }
    const nonWorkingDays = this.nonWorkingDays.filter(nonWorkingDay => {
      return new Date(nonWorkingDay.NonWorkingDay).toLocaleDateString() === date.toLocaleDateString();
    });
    // From specified non working days configurations
    if (nonWorkingDays.length > 0) {
      isNonWorkingDay = true;
    }
    // What was ommited from the business hours configuration
    if (this.isNotScheduledDay(date)) {
      isNonWorkingDay = true;
    }
    return isNonWorkingDay;
  }

  isNotScheduledDay(date: Date) {
    if (this.nonScheduledWeekdayNumbers.includes(date.getDay())) {
      return true;
    } else {
      return false;
    }
  }

  isBreakTime(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    if (!this.currentLocationScheduleTimes) {
      return null;
    } else {
      if (!this.currentLocationScheduleTimes.scheduleTimesDays) {
        return null;
      }
    }

    const dayTimes = this.currentLocationScheduleTimes.scheduleTimesDays.filter(p => this.getDayNumFromValidValueId(p.enumWeekDaysID) === date.getDay());
    // TODO: This needs to be setup to handle multiple break periods in one day.  Breaks are just the space been office hours set in the
    // TODO: This needs to be able to handle times that are not on the hour utilizing minutes.  e.g. 4:30 - 5:30
    // config.
    if (dayTimes.length > 1) {
      const breakStartTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[0].EndTime);
      const breakEndTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[1].StartTime);
      return hours >= breakStartTime.getHours() && hours < breakEndTime.getHours();
    } else {
      return false;
    }
  }

  isBreakTimeColumn(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    if (!this.currentLocationScheduleTimes) {
      return null;
    } else {
      if (!this.currentLocationScheduleTimes.scheduleTimesDays) {
        return null;
      }
    }

    const dayTimes = this.currentLocationScheduleTimes.scheduleTimesDays.filter(p => this.getDayNumFromValidValueId(p.enumWeekDaysID) === date.getDay());
    // TODO: This needs to be setup to handle multiple break periods in one day.  Breaks are just the space been office hours set in the
    // TODO: This needs to be able to handle times that are not on the hour utilizing minutes.  e.g. 4:30 - 5:30
    // config.
    if (dayTimes.length > 1) {
      const breakStartTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[0].EndTime);
      const breakEndTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[1].StartTime);
      return hours >= breakStartTime.getHours() && (hours < breakEndTime.getHours() ||
        (hours === breakEndTime.getHours() && minutes <= breakEndTime.getMinutes()));
    } else {
      return false;
    }
  }

  /*isBetweenBreakTime(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const dayTimes = this.scheduleTimes.scheduleTimesDays.filter(p => this.getDayNumFromValidValueId(p.enumWeekDaysID) === date.getDay());
    // TODO: This needs to be setup to handle multiple break periods in one day.  Breaks are just the space been office hours set in the
    // TODO: This needs to be able to handle times that are not on the hour utilizing minutes.  e.g. 4:30 - 5:30
    // config.
    if (dayTimes.length > 1) {
      const breakStartTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[0].EndTime);
      const breakEndTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[1].StartTime);
      return ((hours >= breakStartTime.getHours() && minutes > breakStartTime.getMinutes()) &&
      (hours <= breakEndTime.getHours() && minutes < breakEndTime.getMinutes()));
    } else {
      return false;
    }
  }*/

  hasCoffeeCupIcon(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    if (!this.currentLocationScheduleTimes) {
      return null;
    } else {
      if (!this.currentLocationScheduleTimes.scheduleTimesDays) {
        return null;
      }
    }

    const dayTimes = this.currentLocationScheduleTimes.scheduleTimesDays.filter(p => this.getDayNumFromValidValueId(p.enumWeekDaysID) === date.getDay());
    // TODO: This needs to be setup to handle multiple break periods in one day.  Breaks are just the space been office hours set in the
    // TODO: This needs to be able to handle times that are not on the hour utilizing minutes.  e.g. 4:30 - 5:30
    // config.
    if (dayTimes.length > 1) {
      const breakStartTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[0].EndTime);
      const breakEndTime = ConversionUtilities.createDateFromTimeSpan(dayTimes[1].StartTime);
      return hours === breakStartTime.getHours() && minutes === breakStartTime.getMinutes();
    } else {
      return false;
    }
  }

  getAppointmentMainBackgroundColor(appointment: DataAppointmentModel): string {
    if (!this.currentLocationScheduleTimes || (!this.currentLocationScheduleTimes.scheduleTimesDays) || !this.docslist || !this.colorSchemes) {
      return;
    }
    const doctor = this.docslist.find(p => p?.DoctorId === appointment.Label_DoctorId);
    const user = this.users.find(p => p.UserID === doctor?.UserId);
    if (doctor && user && user.ColorSchemeID) {
      const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === user.ColorSchemeID);
      if (colorScheme) {
        return colorScheme.BackColor;
      }
    } else {
      if (!appointment || !appointment.Procedure) {
        return;
      }
      const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.Procedure.enumProcedureTypeID);
      if (validValueItem) {
        const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
        if (colorScheme) {
          return colorScheme.BackColor;
        }
      }
    }

    // if appt is block, use block color scheme in vv
    if (this.isBlockAppt(appointment)) {
      const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.enumApptTypeId);
      if (validValueItem) {
        const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
        if (colorScheme) {
          return colorScheme.BackColor;
        }
      }
    }

    return 'grey';
  }

  getAppointmentMainForgroundColor(appointment: DataAppointmentModel): string {
    if (!this.currentLocationScheduleTimes || (!this.currentLocationScheduleTimes.scheduleTimesDays) || !this.docslist || !this.colorSchemes) {
      return;
    }
    const doctor = this.docslist.find(p => p?.DoctorId === appointment.Label_DoctorId);
    const user = this.users.find(p => p.UserID === doctor?.UserId);
    if (doctor && user && user.ColorSchemeID) {
      const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === user.ColorSchemeID);
      if (colorScheme) {
        return colorScheme.ForeColor;
      }
    } else {
      if (!appointment || !appointment.Procedure) {
        return;
      }
      const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.Procedure.enumProcedureTypeID);
      if (validValueItem) {
        const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
        if (colorScheme) {
          return colorScheme.ForeColor;
        }
      }
    }

    // if appt is block, use block color scheme in vv
    if (this.isBlockAppt(appointment)) {
      const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.enumApptTypeId);
      if (validValueItem) {
        const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
        if (colorScheme) {
          return colorScheme.ForeColor;
        }
      }
    }

    return 'black';
  }

  getAppointmentTopBarBackgroundColor(appointment: DataAppointmentModel) {
    if (!appointment) {
      return;
    }
    const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.enumApptTypeId);
    if (validValueItem) {
      const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
      if (colorScheme) {
        return colorScheme.BackColor;
      }
    }

    return 'grey';
  }

  getAppointmentRightBarBackgroundColor(appointment: DataAppointmentModel) {
    if (!appointment) {
      return;
    }
    const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.enumApptStatusId);
    if (validValueItem) {
      const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
      if (colorScheme) {
        return colorScheme.BackColor;
      }
    }

    return 'grey';
  }

  getAppointmentRightBarForgroundColor(appointment: any) {
    if (!appointment) {
      return;
    }
    const validValueItem = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === appointment.enumApptStatusId);
    if (validValueItem) {
      const colorScheme = this.colorSchemes.find(p => p.ColorSchemeId === validValueItem.ColorSchemeId);
      if (colorScheme) {
        return colorScheme.ForeColor;
      }
    }

    return 'grey';
  }

  getPatientFlagImage(flag: PatientFlagDataModel) {
    const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
    if (enu) {
      return enu.IconIDSVG;
    }
  }

  getPatientFlagTooltip(flag: PatientFlagDataModel) {
    const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }

  getAppointmentFlagImage(flag: AppointmentFlagDataModel) {
    const enu = this.appointmentFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumAppoitmentFlagID.toLowerCase());
    if (enu) {
      return enu.IconIDSVG;
    }
  }

  getAppointmentFlagTooltip(flag: AppointmentFlagDataModel) {
    const enu = this.appointmentFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumAppoitmentFlagID.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }

  getDayNumFromValidValueId(enumStr: string): number {
    const vvi = this.staticDataService.getValidValueItemsByItemIds([enumStr])[0];
    return vvi.ItemOrder;
  }

  markWeekEnd(cellData) {
    function isWeekEnd(date) {
      const day = date.getDay();
      return day === 0 || day === 6;
    }
    if (isWeekEnd(cellData.startDate)) {
      return 'lightBlue';
    }
    else {
      return 'white';
    }
  }

  getUser(xauditCreateByUser: string) {
    if (xauditCreateByUser) {
      const usr = this.users.find(p => p.UserID.toLowerCase() === xauditCreateByUser.toLowerCase());
      if (usr) {
        let ret = usr.FirstName;
        if (usr.LastName) {
          ret += ' ' + usr.LastName;
        }
        return ret;
      }
    }
  }

  onZAppointmentRendered(e){
    var el = e.appointmentElement;
        el.onmouseenter = function(args)   {
            setTimeout(function(){
                e.component.showAppointmentTooltip(e.appointmentData,     e.appointmentElement, e.targetedAppointmentData);
            },300);

        };

  }


  protected readonly ApptTypeEnum = ApptTypeEnum;

  isBlockAppt(appt: any) {
    if (appt.enumApptTypeId === ApptTypeEnum.BlockOut || appt.enumApptTypeId === ApptTypeEnum.BlockIn) {
      return true;
    }
    else {
      return false;
    }
  }
}
